<template>
  <div class="row footer ">
      <div class="col-md-12">
       
      <div class="row company-info">
        <div class=" col-md-12">
          <div class="logo left" style="padding-bottom: 40px;">
          <img  class="item" src="@static/img/common/logo.png" alt="logo">
          <div class="info" style="color: #333;font-size: 24px;" v-text="$t('footer.info.title')"></div>
        </div>
        </div>
        
        <div class="col-md-12">
          <div class="left" style="color: #666; font-size: 20px;">
            <!-- <div class="info" style="color: #00BBB1;font-size: 24px;">MENU</div>
            <div @click="go('/specified_commercial_transactions')" class="info" style="color: #666;font-size: 18px; cursor: pointer;text-decoration: underline;">特定商取引法について</div>
            <div  @click="go('/personal_information_protection_policy')" class="info" style="color: #666;font-size: 18px; cursor: pointer;text-decoration: underline;">個人情報保護方針</div> -->
            <div class="info" style="color: #999;padding-top: 30px;">
              <span class="title" v-text="$t('footer.info.emailName')"></span>
              <span v-text="$t('footer.info.email')"></span>
            </div>
            <div class="info" style="color: #999;">
              <span class="title" v-text="$t('footer.info.addrName')"></span>
              <span v-text="$t('footer.info.addr')"></span>
            </div>
          </div>
             <div class="right" style="color: #666; font-size: 20px;">
            <!-- <div v-text="$t('footer.info.addr')">
              1-46-11-304 Fumatagawa, Asahi Ward, Yokohama City, Kanagawa, Japan 
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  methods:{
    go : function (url) {
       this.$router.push({path:url})
       
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/common/footer.vue